import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18next
  // load translation using http -> see /public/locales/{{Lng}} (i.e. /public/locales/en)
  .use(Backend)
  // detect user language
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next with options
  .init({
    fallbackLng: "en", // fallback to en if user preffered language is not available
    fallbackNS: "translation", // fallback to translation (default) Namespace if provided Namesapce not available
    returnObjects: true, // returns whole object
    supportedLngs: ["en"],
  });

export default i18next;
